// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App'
import VueRouter from 'vue-router'
import routes from '@/vue/router/routes'
import UUID from 'vue-uuid'
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.css';
import VueDatePicker from "@mathieustan/vue-datepicker";
import '@mathieustan/vue-datepicker/dist/vue-datepicker.min.css';
import store from './vue/store';
import { mapGetters, mapMutations } from 'vuex';
import apiClient from './vue/http/axios';
import Vuelidate from 'vuelidate';


Vue.use(UUID)

Vue.use(Vuetify);

Vue.use(VueRouter);

Vue.use(VueDatePicker);

Vue.use(Vuelidate);


const router = new VueRouter({
  routes: routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  const companyId = localStorage.getItem('companyId');
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  // Si tiene token y companyId y va a '/' desde otro lado que no sea /dashboard
  if (token && companyId && to.path === '/' && from.path !== '/dashboard') {
    if (to.path !== '/dashboard') {
      return next({ path: '/dashboard' });
    } else {
      return; // evitar navegación duplicada
    }
  }

  // Si requiere auth pero no tiene token o companyId
  if (requiresAuth && (!token || !companyId)) {
    if (to.path !== '/') {
      return next({ path: '/' });
    } else {
      return; // evitar navegación duplicada
    }
  }

  return next(); // continuar normalmente
});



// Moment translate
const moment = require('moment')
require('moment/locale/es')
Vue.use(require('vue-moment'), {
  moment
})


Vue.prototype.$http = apiClient;


Vue.mixin({
  methods: {
    ...mapMutations([
      'setRangeDate',
      'setLocation',
      'setUser',
      'setCompany',
      'setEmail',
      'setToken',
      'setLoader'
    ]),
    encrypt(data) {
      let CryptoJS = require("crypto-js");
      let payload = "G7qeaR2Yb4DAgk92ZQHdjQ==|gfYvWJ0vVdX142/xpsGPW8Fsgc/dGeQPFtaazcUMjQo=|VF/bl6Ae5CVTtQTPCrmAgQ==".split("|");
      let iv = payload[0], hmac = payload[1], cipherText = payload[2];
      let passphraseDgst = CryptoJS.SHA256("ImAwesomeAndHappy").toString();
      let key = passphraseDgst;
      let encrypted = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        CryptoJS.enc.Hex.parse(passphraseDgst),
        {iv:CryptoJS.enc.Base64.parse(iv)}
      );
      return encrypted
    },
    decrypt_info(data){
      let CryptoJS = require("crypto-js");
      let iv = CryptoJS.enc.Base64.parse("kT+uMuPwUk2LH4cFbK0GiA==")
      let key = CryptoJS.enc.Hex.parse("6476b3f5ec6dcaddb637e9c9654aa687")
      let decrypted_value = CryptoJS.AES.decrypt(data,  key,  {mode: CryptoJS.mode.CBC,  iv : iv}).toString(CryptoJS.enc.Utf8)
      return JSON.parse(decrypted_value);
    },
  },
  computed: {
      ...mapGetters([
        'getStartDate',
        'getEndDate',
        'getLocation',
        'getUser',
        'getCompany',
        'getEmail',
        'getToken',
        'getLoader'
      ]),
  }
});


/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  render: (h) => h(App),
});
